module.exports = __webpack_public_path__ + "static/media/logo.ef5626ed.png";